import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';

const PatternsLayout: React.FC = memo(() => {
  return (
    <div 
      className="flex flex-col md:flex-row gap-6"
      role="main"
      aria-label="Patterns documentation"
    >
      <nav 
        className="md:w-[250px] md:min-w-[150px] md:max-w-[300px] md:flex-shrink-0"
        role="navigation"
        aria-label="Patterns navigation"
      >
        <div className="sticky top-4 h-[calc(100vh-8rem)] overflow-y-auto">
          <Sidebar pageType="patterns" />
        </div>
      </nav>
      
      <main 
        className="flex-grow overflow-y-auto pb-16"
        role="region"
        aria-label="Pattern content"
      >
        <Outlet />
      </main>
    </div>
  );
});

PatternsLayout.displayName = 'PatternsLayout';

export default PatternsLayout; 